import React from 'react';
import './panelists.scss';
import Panelist from './Panelist';
import { lang } from '../lang';

function Panelists() {
  const images = [
    'https://courageous-cdn-media-bucket.s3.amazonaws.com/regeneron/asha.jpg',
    'https://courageous-cdn-media-bucket.s3.amazonaws.com/regeneron/fatima.jpg',
    'https://courageous-cdn-media-bucket.s3.amazonaws.com/regeneron/willie.jpg'
  ];
  return (
    <div className="panelists">
      {lang.panelists.map((list, i) => {
        return <Panelist data={list} image={images[i]} key={list.name} index={i} />;
      })}
    </div>
  );
}

export default Panelists;
